/* eslint-disable prefer-const */
import { API_CONFIG, getApiUrl } from "@/config/apiConfig";
import { getAuthHeaders } from "./authApi";
import { handleListResponse } from "./apiHandler";

export const getAllSubscriptionWithCurrent = async (userId, duration) => {
  try {
    let endpoint = API_CONFIG.endpoints.subscriptions.all.replace(
      ":userId",
      userId,
    );
    let url = `${getApiUrl(endpoint)}?`;

    if (duration) url += `duration=${duration}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch Subscriptions");
  } catch (error) {
    console.error("Error fetching Subscription list:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const create_Subscriptions = async (userId, plan_id) => {
  try {
    let endpoint = API_CONFIG.endpoints.subscriptions.create_subscription;
    let url = `${getApiUrl(endpoint)}`;

    const subscription_data = {
      user_id: userId,
      plan_id: plan_id,
    };

    const response = await fetch(url, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(subscription_data),
    });

    return await handleListResponse(response, "Fetch Subscriptions");
  } catch (error) {
    console.error("Error fetching Subscription list:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const upgrade_Subscriptions = async (userId, plan_id) => {
  try {
    let endpoint = API_CONFIG.endpoints.subscriptions.upgrade_subscription;
    let url = `${getApiUrl(endpoint)}`;

    const subscription_data = {
      user_id: userId,
      new_plan_id: plan_id,
    };

    const response = await fetch(url, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(subscription_data),
    });

    return await handleListResponse(response, "Fetch Subscriptions");
  } catch (error) {
    console.error("Error fetching Subscription list:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};
